module.exports = __webpack_public_path__ + "img/transporter-3.6281ed15.svg";